import Iconify from "@/src/components/iconify/Iconify";

import Link from "next/link";
import IconCode from "@/src/lib/iconCode";
import { callHref } from "@/src/lib/util/callUtils";

const CentreFacilitiesNearYou = ({ item }) => {
    return (
        <>
            <div className="group relative">
                <div className="border border-slate-300 border-dashed p-2 hover:border-primary">
                    <div className="flex justify-between items-center">
                        <Link href={`/locate-us/${item?.urlSlug}`}>
                            <p className="text-sm text-black font-normal flex items-center">
                                <Iconify
                                    icon={IconCode.outlinedLocation}
                                    className="text-primary"
                                />
                                {item.centreDisplayName}
                            </p>
                        </Link>
                        <Link href={callHref(item?.centreMobile)}>
                            <p className="text-sm text-black font-medium flex items-center">
                                <Iconify
                                    icon={IconCode.mobile}
                                    className="text-primary"
                                />
                                {item?.centreMobile}
                            </p>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};
export default CentreFacilitiesNearYou;
